import { facadeApi } from 'api'
import { MiroConfigStatusResponse } from 'types/miro'

export const fetchMiroConfigStatusApi = () => facadeApi.get<MiroConfigStatusResponse>('/miro/config/status')
